/* CUSTOM[aloe-shop] P2: Subscription-Block Enhancements
   Siehe blocks/aloe-shop-sub-enhance.liquid + CUSTOMIZATIONS.md
   Macht: Tab-Style aktivieren, Vorteils-Icons (im Liquid),
          dynamischer UVP-Sparvergleich, 5%-Hinweis, Best-Price-Badge.
   Buyer-Consent-Akkordeon: v2026-05-19-b (cache-bust)
*/
(function () {
  'use strict';

  function parsePrice(s) {
    if (!s) return null;
    var m = String(s).replace(/\s/g, '').match(/[\d.,]+/);
    if (!m) return null;
    var num = m[0].replace(/\./g, '').replace(',', '.');
    var n = parseFloat(num);
    return isNaN(n) ? null : n;
  }

  function formatPrice(n) {
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function enhanceOne(enhanceEl) {
    if (enhanceEl.dataset.aloeInited === '1') return;

    var appContainer = document.querySelector('.shopify_subscriptions_app_container');
    if (!appContainer) return false;

    enhanceEl.dataset.aloeInited = '1';

    var cfg = enhanceEl.dataset;
    var productPage = enhanceEl.closest('[data-js-product-component]') || document;

    // --- 1. Tab-Style-Override aktivieren ---
    if (cfg.tabStyle === 'true') {
      appContainer.setAttribute('data-aloe-tab-style', 'true');
    }

    var otpLabel = appContainer.querySelector('label.tab_label[for^="tab_otp_"]');
    var subLabel = appContainer.querySelector('label.tab_label[for^="tab_subscribe_"]');
    var otpRadio = appContainer.querySelector('input.tab_radio[id^="tab_otp_"]');
    var subRadio = appContainer.querySelector('input.tab_radio[id^="tab_subscribe_"]');
    var subPanel = appContainer.querySelector('.subscribe_panel');

    // --- 1a. Vorteils-Icons in den Abo-Panel moven (sichtbar nur wenn Abo aktiv) ---
    var benefitsEl = enhanceEl.querySelector('.aloe-sub-enhance__benefits');
    if (benefitsEl && subPanel) {
      subPanel.appendChild(benefitsEl);
      benefitsEl.classList.add('aloe-sub-enhance__benefits--in-panel');
    }

    // --- 1b. Subscription-Policy-Text in den Abo-Panel moven
    // (Default-Position vom App-Block: unter beiden Tabs, immer sichtbar.
    //  Soll: nur sichtbar wenn Abo aktiv und INNERHALB der Abo-Box.) ---
    var policyEl = appContainer.querySelector('.shopify_subscriptions_app_policy');
    if (policyEl && subPanel) {
      subPanel.appendChild(policyEl);
      policyEl.classList.add('aloe-sub-enhance__policy--in-panel');
    }

    // --- 1c. Shopify-Buyer-Consent (langer Disclaimer von Shop Pay) auch in
    // den Abo-Panel moven. Rechtlich relevant nur fuer Abo-Bestellungen.
    // Shop Pay setzt default class="hidden" + aria-hidden="true" -> beides
    // explizit entfernen, damit der Text im Abo-Panel sichtbar ist.
    // KOMPAKT: in <details> einwickeln, Default zugeklappt mit Toggle-Label. ---
    var buyerConsentEl = document.getElementById('shopify-buyer-consent');
    if (buyerConsentEl && subPanel && !buyerConsentEl.dataset.aloeWrapped) {
      subPanel.appendChild(buyerConsentEl);
      buyerConsentEl.classList.remove('hidden');
      buyerConsentEl.removeAttribute('aria-hidden');
      buyerConsentEl.classList.add('aloe-sub-enhance__consent--in-panel');
      // In <details>-Akkordeon einwickeln (nur einmal)
      var details = document.createElement('details');
      details.className = 'aloe-sub-consent-acc';
      var summary = document.createElement('summary');
      summary.className = 'aloe-sub-consent-acc__summary';
      summary.innerHTML = '<span class="aloe-sub-consent-acc__label">Hinweise zum Abo-Kauf</span><span class="aloe-sub-consent-acc__chev" aria-hidden="true">▾</span>';
      details.appendChild(summary);
      buyerConsentEl.parentNode.insertBefore(details, buyerConsentEl);
      details.appendChild(buyerConsentEl);
      buyerConsentEl.dataset.aloeWrapped = '1';
    }

    // --- 2. 5%-Tagesrabatt-Hinweis am Einmalkauf-Tab ---
    if (cfg.showOtpHint === 'true' && otpLabel && !otpLabel.querySelector('.aloe-tab-otp-hint')) {
      var hint = document.createElement('span');
      hint.className = 'aloe-tab-otp-hint';
      hint.textContent = cfg.otpHintText || '+ 5% Tagesrabatt im Warenkorb';
      otpLabel.appendChild(hint);
    }

    // --- 2b. Spar-Badge am Abo-Tab ("-7,70 EUR" oder "-7%") ---
    // Berechnet dynamisch aus dem subscription-Tab-Preis und compare-Preis,
    // funktioniert fuer alle Pakete ohne hardcoded Werte.
    if (subLabel && !subLabel.querySelector('.aloe-tab-sub-badge')) {
      var subPriceEl = subLabel.querySelector('.price');
      var subCompareEl = subLabel.querySelector('.tab_price_compare');
      var subPrice = parsePrice(subPriceEl ? subPriceEl.textContent : '');
      var subCompare = parsePrice(subCompareEl ? subCompareEl.textContent : '');
      if (subPrice && subCompare && subCompare > subPrice) {
        var saving = subCompare - subPrice;
        var savingBadge = document.createElement('span');
        savingBadge.className = 'aloe-tab-sub-badge';
        savingBadge.textContent = '-' + formatPrice(saving);
        // Direkt nach dem Label-Titel "Abonnement" einfuegen
        var subTitleSpan = subLabel.querySelector('span:first-child');
        if (subTitleSpan) {
          subTitleSpan.insertAdjacentElement('afterend', savingBadge);
        } else {
          subLabel.appendChild(savingBadge);
        }
      }
    }

    // --- 3. "Bester Preis"-Badge auf Monats-Abo-Option ---
    if (cfg.showBestPriceBadge === 'true') {
      var matchText = (cfg.bestPriceMatchText || 'Jeden Monat').toLowerCase();
      var badgeText = cfg.bestPriceBadgeText || 'Bester Preis';
      var planLabels = appContainer.querySelectorAll('.group_list_item .selling_plan_and_price_wrapper > span:first-child');
      for (var i = 0; i < planLabels.length; i++) {
        var t = (planLabels[i].textContent || '').toLowerCase();
        if (t.indexOf(matchText) !== -1) {
          if (!planLabels[i].querySelector('.aloe-best-price-badge')) {
            var badge = document.createElement('span');
            badge.className = 'aloe-best-price-badge';
            badge.textContent = badgeText;
            planLabels[i].appendChild(badge);
          }
          break;
        }
      }
    }

    // --- 4. UVP-Sparvergleich-Container vorbereiten ---
    var uvpContainer = null;
    var uvpPrice = null;
    var otpPrice = null;
    if (cfg.showUvpSaving === 'true') {
      var compareDel = productPage.querySelector('.product-price--compare span[style*="line-through"]');
      uvpPrice = parsePrice(compareDel ? compareDel.textContent : '');
      var otpPriceEl = otpLabel ? otpLabel.querySelector('.price') : null;
      otpPrice = parsePrice(otpPriceEl ? otpPriceEl.textContent : '');

      if (uvpPrice) {
        uvpContainer = document.createElement('span');
        uvpContainer.className = 'aloe-uvp-saving aloe-uvp-saving--hidden';
        // Direkt nach dem Subscription-App-Block einfuegen (vor unserem Enhance-Block)
        enhanceEl.parentNode.insertBefore(uvpContainer, enhanceEl);
      }
    }

    // --- 5. Sparvergleich-Update bei Tab-/Plan-Wechsel ---
    function syncTabState() {
      // Body-Klasse fuer Effektiv-Preis-Badge sichtbar/unsichtbar
      var isSub = subRadio && subRadio.checked;
      var isOtp = otpRadio && otpRadio.checked;
      document.body.classList.toggle('aloe-sub-active', !!isSub);
      // Tab-Label-Klassen togglen
      if (otpLabel) otpLabel.classList.toggle('aloe-otp-active', !!isOtp);
      if (subLabel) subLabel.classList.toggle('aloe-sub-active-tab', !!isSub);
      // Inline-Style + !important direkt setzen - Subscription-App nutzt
      // ID-Selektor mit Specificity 140 die jede class-only-Regel schlaegt.
      // Nur Inline-!important garantiert dass unser Akzent winwt.
      if (otpLabel) {
        if (isOtp) {
          otpLabel.style.setProperty('background-color', '#f5fbe1', 'important');
          otpLabel.style.setProperty('border-color', '#a4d600', 'important');
          otpLabel.style.setProperty('border-width', '2px', 'important');
        } else {
          otpLabel.style.removeProperty('background-color');
          otpLabel.style.removeProperty('border-color');
          otpLabel.style.removeProperty('border-width');
        }
      }
      // Zurueck-Button OBEN im subscribe_panel injizieren (nur wenn isSub)
      if (isSub && subPanel && !subPanel.querySelector('.aloe-sub-back-bar')) {
        var bar = document.createElement('div');
        bar.className = 'aloe-sub-back-bar';
        bar.innerHTML = '<span class="aloe-sub-back-bar__text">Abo-Modus aktiv</span>'
                      + '<button type="button" class="aloe-sub-back-bar__btn" data-aloe-sub-back-top>Zurück auf Einmalkauf</button>';
        subPanel.insertBefore(bar, subPanel.firstChild);
        var backBtn = bar.querySelector('[data-aloe-sub-back-top]');
        backBtn.addEventListener('click', function(){
          if (otpRadio) otpRadio.click();
          var subCtaLabel = document.querySelector('[data-aloe-sub-cta-label]');
          if (subCtaLabel) subCtaLabel.textContent = 'Auf Abo umstellen';
        });
      }
    }

    function updateUvpSaving() {
      syncTabState();
      if (!uvpContainer || !uvpPrice) return;
      // Welcher Tab ist aktiv?
      var isSub = subRadio && subRadio.checked;
      if (!isSub) {
        uvpContainer.classList.add('aloe-uvp-saving--hidden');
        return;
      }
      // Welche Plan-Option ist ausgewaehlt? Falls keine, ersten enabled nehmen
      var selectedPlanInput = appContainer.querySelector(
        '.group_list_item input[type="radio"][data-radio-type="selling_plan"]:checked:not([disabled])'
      );
      if (!selectedPlanInput) {
        selectedPlanInput = appContainer.querySelector(
          '.group_list_item input[type="radio"][data-radio-type="selling_plan"]:not([disabled])'
        );
      }
      var planPrice = selectedPlanInput ? parsePrice(selectedPlanInput.getAttribute('data-variant-price')) : null;
      if (!planPrice) {
        uvpContainer.classList.add('aloe-uvp-saving--hidden');
        return;
      }
      var saving = uvpPrice - planPrice;
      if (saving <= 0) {
        uvpContainer.classList.add('aloe-uvp-saving--hidden');
        return;
      }
      var prefix = cfg.uvpSavingPrefix || 'Du sparst ';
      var suffix = cfg.uvpSavingSuffix || ' gegenueber UVP';
      uvpContainer.textContent = prefix + formatPrice(saving) + suffix;
      uvpContainer.classList.remove('aloe-uvp-saving--hidden');
    }

    // Listener auf Tab- + Plan-Wechsel
    if (otpRadio) otpRadio.addEventListener('change', updateUvpSaving);
    if (subRadio) subRadio.addEventListener('change', updateUvpSaving);
    appContainer.querySelectorAll('input[type="radio"][data-radio-type="selling_plan"]').forEach(function (r) {
      r.addEventListener('change', updateUvpSaving);
    });
    // Tab-Label-Klicks: triggern den change schon, aber doppelte Sync-Sicherheit
    appContainer.querySelectorAll('label.tab_label').forEach(function (l) {
      l.addEventListener('click', function () { setTimeout(syncTabState, 0); });
    });
    // Initial einmal aufrufen (falls Seite mit Abo-Tab vorausgewaehlt geladen)
    updateUvpSaving();

    // --- Mengen-Tier-Selector: Click-Handler + Quantity-Sync ---
    // Widget wird direkt via custom_liquid Block gerendert (snippets/aloe-shop-bulk-tiers).
    // Hier nur: Click setzt Theme-Quantity-Picker, Sync wenn Quantity manuell geaendert.
    var bulkTiersEl = document.querySelector('.aloe-bulk-tiers');
    var qtyInput = productPage.querySelector('input[name="quantity"]') ||
                   productPage.querySelector('[data-js-product-quantity-input]');

    if (bulkTiersEl && qtyInput) {
      var tierButtons = bulkTiersEl.querySelectorAll('.aloe-bulk-tier');

      tierButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qty = parseInt(btn.getAttribute('data-bulk-qty'), 10) || 1;
          tierButtons.forEach(function (b) { b.classList.remove('aloe-bulk-tier--active'); });
          btn.classList.add('aloe-bulk-tier--active');
          qtyInput.value = String(qty);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });

      // Quantity-Picker -> Tier-Active-State syncen
      var syncTiersFromQty = function () {
        var current = parseInt(qtyInput.value, 10) || 1;
        var matched = false;
        tierButtons.forEach(function (b) {
          var bQty = parseInt(b.getAttribute('data-bulk-qty'), 10) || 1;
          if (bQty === current) {
            b.classList.add('aloe-bulk-tier--active');
            matched = true;
          } else {
            b.classList.remove('aloe-bulk-tier--active');
          }
        });
        if (!matched && current > 3 && tierButtons.length) {
          tierButtons[tierButtons.length - 1].classList.add('aloe-bulk-tier--active');
        }
      };
      qtyInput.addEventListener('change', syncTiersFromQty);
      qtyInput.addEventListener('input', syncTiersFromQty);
      syncTiersFromQty();
    }

    return true;
  }

  function initAll() {
    document.querySelectorAll('.aloe-sub-enhance').forEach(function (el) {
      enhanceOne(el);
    });
  }

  function waitForAppBlock(maxMs) {
    var start = Date.now();
    var timer = setInterval(function () {
      var ok = document.querySelector('.shopify_subscriptions_app_container');
      if (ok || Date.now() - start > maxMs) {
        clearInterval(timer);
        if (ok) initAll();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForAppBlock(5000); });
  } else {
    waitForAppBlock(5000);
  }

  // Theme-Editor Re-Render
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
